import LinksSectionImplementation from '../implementation/sections/LinksSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiLinksSectionDTO,
  LinksSectionDTO,
} from '@lib/strapi/dtos/components/sections/linksSection.dto';

const LinksSection = (props: ComponentProps<LinksSectionDTO>) => {
  return <LinksSectionImplementation {...props}></LinksSectionImplementation>;
};

export default LinksSection;
